import gql from 'graphql-tag'

export const GET_ALL_PARTNERS = gql`
    query {
        Organizations(where:{status:{_eq: "Active"},status:{_eq: "Active"}}){
            id
            name
            partnerType
            partnerCode
        }
    }
`
export const GET_PARTNER_FROM_ORG = gql`
    query Organizations($orgId:uuid!){
        Organizations(where: {status:{_eq: "Active"},parentPartnerId: {_eq: $orgId}}) {
            id
        }}
`
export const GET_SCHEME_POINT_HISTORY = gql`
    query SchemePointHistory($startDate:date!,$endDate:date!,$orgId:[uuid!],$schemeId:uuid!){
        SchemePointHistory(where: {month: {_gte: $startDate, _lte: $endDate}, partnerId: {_in: $orgId}, schemeId: {_eq: $schemeId}}) {
            id
            month
            eligiblePoint
            isEligible
            earnPoint
            partnerId
            myTeamEligiblePoint
            schemeId
            Partner{
                id
                name
                partnerCode
            }
        }}
`
export const GET_SCHEME_DETAIL_WITH_POINTS = gql`
    query Scheme($id:uuid!,$partnerId:uuid!){
        Scheme(where:{id:{_eq:$id}}){
            id
            name
            description
            backgroundImage
            SchemaPointView(order_by: {sequenceNumber: asc, productSequenceNumber: asc}){
                productname
                points
                quantity
            }
            SchemeEnrollments(where: {partnerId: {_eq: $partnerId}}){
                id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId
                redemPoint redemptioInProgress transferPoints adjustment returnOrderPoint
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            pointMethod
            points
            isAutoJoin
            goalPoints
            isSelfRedemption
            applicableOn
            minMonthlyPointsForEligible
            isMultiRedemptionAllowed
            isHerirachyScheme
            criteria
            isSpecialScheme
        }
    }
`

export const GET_TRANSFER_POINT_HISTORY = gql`
    query getTransferPointHistory($partnerId:uuid!,$schemeId:uuid!,$startDate:timestamptz!,$endDate:timestamptz!){
        SchemePointsHistoryOrderWise(where:{partnerId:{_eq:$partnerId},schemeId:{_eq:$schemeId}, Order:{date:{_gte:$startDate,_lte:$endDate}}, transferPoint: {_neq: 0}},distinct_on:orderId, order_by: {orderId: asc, Order: {createdOn: desc}}){
            id
            transferPoint
            createdOn
            Order{
                id
                from
                status
                createdOn
                orderNum
                invoiceNumber
                invoiceDate
                invoiceNote
                date
                orderType               
                OrderItems{
                    productId
                    ToOrganization{name PartnerType{name prefix} }
                    ToCustomer{name}
                    FromOrganization{name PartnerType{name prefix} }
                    orderItemId: id
                    orderItemStatus: status
                    Product{name id productLineCode ProductLine{name} OEM {name}}
                    Batch{batch id productId status sku}
                }}
        }
    }
`
